import React from "react";
import useNivelesLogic from "./hooks/useNivelesLogic";
import NivelesView from "./pages/NivelesView.jsx";

export default function Niveles() {
  const logic = useNivelesLogic();
  return <NivelesView {...logic} />;
}
